import React from 'react';

import { H4Styled } from './H4.style';

export const H4 = ({ children, ...props }: { children: any }) => {
  return <H4Styled {...props}>{children}</H4Styled>;
};
